export const API_GUARD = "branch";

export const URL = "https://api.opstelecom.com.br/api";
